var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUploadSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 7.446h1.732v7.929c0 .103.084.187.188.187H12.7a.188.188 0 00.187-.187v-7.93h1.737c.157 0 .244-.18.148-.302L12.148 3.82a.188.188 0 00-.296 0L9.227 7.141a.188.188 0 00.148.305zm11.203 7.226h-1.406a.188.188 0 00-.188.187v3.61H5.016v-3.61a.188.188 0 00-.188-.187H3.422a.188.188 0 00-.188.187v4.64c0 .416.336.75.75.75h16.032a.75.75 0 00.75-.75v-4.64a.188.188 0 00-.188-.187z",
    fill: "#4471B8"
  })));
}
export default __webpack_public_path__ + "img/289eff43bada42d4c5e1a871304b3c7d.svg";
export { SvgFileUploadSmall as ReactComponent };